// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"131":"stock","571":"settings"}[chunkId] + "-legacy." + {"131":"ec7ed06e","571":"eab411f2"}[chunkId] + ".js";
};